export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";